import Admin from "../Admin";
import React from "react";
import CardAdminInsuranceSubTypeList from "../../../Component/Card/Admin/InsuranceSubType/CardAdminInsuranceSubTypeList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";
import Security from "../../../Utility/Security";

export default class InsuranceSubTypeList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminInsuranceSubTypeList />
        );
    }

    /**
     * Render the header.
     */
    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/insuranceSubType"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                disabled={!Security.hasPermission("insuranceSubType.manage")}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Insurance Subtypes" buttons={buttons} />
        );
    }
}
